<template>
    <div class="konsumen-card">
        <div v-for="(data, idx) in dataList" :key="`${idx}-card-konsumen`">
            <SOSlotCard
                :id="`konsumen-${idx}`"
                :last-id="`getLastId`"
                :card-type="typeCard"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
            >
                <template v-slot:card_body>
                    <div
                        class="d-grid-12"
                        style="border-bottom: 1px solid #EDEDED; padding: 8px 18px; margin: -8px -18px;"
                    >
                        <p class="grid-cspan-6 m-d-0" style="color: #000000; font-size: 14px">{{ data.nama }}</p>
                        <p class="grid-cspan-6 m-d-0" style="font-size: 14px">{{ data.telp }}</p>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import { moduleName } from "../store/state";

export default {
    name: "CardConsument",
    props: {
        typeCard: {
            type: String,
            default: "none",
        },
        dataList: {
            type: Array,
            default: function() {
                return [];
            },
        },
        loadData: {
            type: Function,
            required: true,
        },
    },
    components: {
        SOSlotCard,
    },
    computed: {
        ...mapGetters(moduleName, {
            konsumenEnd: "konsumenEnd",
        }),
    },
    methods: {
        ...mapActions({
            toggleKonsumenShow: `${moduleName}/toggleKonsumenShow`,
        }),
        doLoadMore() {},
        toggleCard() {},
    },
};
</script>
<style scoped src="../static/style.css"></style>
